import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import {
  ActivePromotionsGridFC,
  ActivePromotionsGridFCProps,
} from 'promotions/components/ActivePromotionsGrid/ActivePromotionsGridFC';

import { connectFC } from 'utils/connectFC';

import { useSelectedProvider } from 'root/hooks/useSelectedProvider';

const useStrings = (): ActivePromotionsGridFCProps['strings'] => {
  const intl = useIntl();
  return useMemo(
    () => ({
      buttons: {
        showAllActive: intl.formatMessage({
          id: 'components.activePromotionsGrid.buttons.showAllActive',
        }),
      },
      page: {
        title: intl.formatMessage({ id: 'components.activePromotionsGrid.page.title' }),
        subtitle: intl.formatMessage({ id: 'components.activePromotionsGrid.page.subtitle' }),
        subtitleNoOrders: intl.formatMessage({
          id: 'components.activePromotionsGrid.page.subtitleNoOrders',
        }),
      },
      promotionCard: {
        viewDetails: intl.formatMessage({
          id: 'components.activePromotionsGrid.promotionCard.viewDetails',
        }),
        tooltipInfo: intl.formatMessage({
          id: 'components.activePromotionsGrid.promotionCard.tooltipInfo',
        }),
      },
      upcomingPromotionsCard: {
        upcoming: intl.formatMessage({
          id: 'components.activePromotionsGrid.upcomingPromotionsCard.upcoming',
        }),
      },
      emptyActivePromotions: {
        title: intl.formatMessage({
          id: 'components.activePromotionsGrid.emptyActivePromotions.title',
        }),
        subtitle: intl.formatMessage({
          id: 'components.activePromotionsGrid.emptyActivePromotions.subtitle',
        }),
      },
    }),
    [intl],
  );
};
type ActivePromotionsGridProps = Omit<
  ActivePromotionsGridFCProps,
  'strings' | 'canSelfAssignCampaigns'
>;
export const ActivePromotionsGrid = connectFC(
  ActivePromotionsGridFC,
  (props: ActivePromotionsGridProps) => {
    const strings = useStrings();
    const selectedProvider = useSelectedProvider();

    return {
      ...props,
      strings,
      canSelfAssignCampaigns: Boolean(selectedProvider?.permissions.selfAssignCampaigns),
    };
  },
);
